export { default } from './HBBrandAvatar';
export type { HBBrandAvatarProps } from './HBBrandAvatar.types';
